'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const Mediator = require('./../../../../core/mediator');
const FormBuilder = require('./../../builder');
const ElementClass = require('./../../elementClass');

const RteConfig = require('./../../../../services/rte/config');

FormBuilder.register('rte', function(config) {
  let self = new ElementClass(config);
  let $element;
  let instance;

  self.render = function($wrapper) {
    $element = jQuery(`<div>${config.value}</div>`);

    if (self.label) {
      let $label = jQuery('<label/>');

      if (self.labelClass) {
        $label.addClass(self.labelClass);
      }

      $label.append(self.label);

      $wrapper.append($label);
    }

    if (config.minHeight) {
      $element.css('min-height', config.minHeight);
    }

    _.merge(CKEDITOR.config, RteConfig.buttons);
    $element.attr('contenteditable', true);

    let settings = RteConfig.config;
    Mediator.publish('before:rte:config', settings);

    CKEDITOR.disableAutoInline = true;
    CKEDITOR.inline($element.get(0), settings);
    CKEDITOR.once('currentInstance', function() {
      instance = CKEDITOR.currentInstance;

      if (instance) {
        let $instance = jQuery('#cke_' + instance.ui.editor.name);

        $instance.addClass('cloud-cke');

        config.instance = instance;
      }
    });

    CKEDITOR.ui.on('ready', function() {
      jQuery('iframe.cke_panel_frame').contents().find('head').append(jQuery('#cloud-css').clone().get(0));
    });

    $wrapper.append($element);
  };

  self.getData = function() {
    return $element.html();
  };

  return self;
});
